import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';

import { AllotmentListDataService } from 'src/app/products/allotment/list/allotment-list.data';
import { AllotmentEditorView } from './allotment-editor.view';

interface AllotmentEditorControllerProps {
    value: number | null;
    mode: ControlMode;
    onChanged: (value: number | null) => void;
    setBusy(isBusy: boolean);
    label?: string;
	required?: boolean;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class AllotmentEditorController extends React.Component<AllotmentEditorControllerProps, any> {
    protected allotmentListDataService: AllotmentListDataService;

    constructor(props) {
        super(props);
        this.allotmentListDataService = AllotmentListDataService.make();
    }

    @autobind
    protected allotmentQuery(q?: string): Promise<QueryResult<AllotmentSummary>> {
        return new Promise<QueryResult<AllotmentSummary>>((resolve, reject) => {
            this.props.setBusy(true);
            this.allotmentListDataService.addFilter('isDeleted', 'eq', false);
            this.allotmentListDataService.addSorting('id', 'asc', true);
            this.allotmentListDataService.searchKeywords = q;
            this.allotmentListDataService.load(query => query)
                .then((items) => {
                    this.props.setBusy(false);
                    resolve({
                        items: items,
                        totalCount: this.allotmentListDataService.count
                    });
                });
        });
    }

    render() {
        return (
            <AllotmentEditorView
                allotmentRequest={{ query: this.allotmentQuery, dataSet: this.allotmentListDataService }}
                onChanged={this.props.onChanged}
                value={this.props.value}
                mode={this.props.mode}
                label={this.props.label}
                required={this.props.required}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/products/allotment/parts/allotment-editor.controller.tsx